<mat-card>
    <div *ngIf="title; else other_content">
        <mat-card-title style="text-align: center"><label translate>INVOICING_DATA.BILLING_DATA_SUMM</label> </mat-card-title>
    </div>

    <ng-template #other_content>
        <div style="display: flex; justify-content: space-between; padding-bottom: 1.2rem">
            <div class="titleTabContent" style="justify-content: flex-start">
                <div style="display: flex">
                    <div><span translate>INVOICING_DATA.SUBSCRIBER_AND_BILLING_DATA</span></div>
                </div>
            </div>
        </div>
    </ng-template>

    <form #mainDataForm="ngForm">
        <mat-card-content>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label translate>USER_FORM.COMPANY_NAME</mat-label>
                    <input
                        [disabled]="imInSubscriptionsManagement"
                        #companyName="ngModel"
                        matInput
                        required
                        [(ngModel)]="c.CompanyName"
                        name="CompanyName"
                    />
                    <mat-hint *ngIf="!companyName.valid && companyName.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label translate>USER_FORM.COUNTRY</mat-label>
                    <mat-select
                        #country="ngModel"
                        required
                        placeholder="{{ 'USER_FORM.COUNTRY' | translate }}"
                        [(ngModel)]="c.Country"
                        name="Country"
                        (selectionChange)="setRequired()"
                    >
                        <mat-option *ngFor="let country of selectableCountries" [value]="country.code">
                            {{ country.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="!country.valid && country.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>

                <div style="display: flex; justify-content: space-between" *ngIf="showVATNumber">
                    <div style="display: flex; flex-grow: 4">
                        <div class="square">{{ c.Country }}</div>
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label translate>USER_FORM.VATNUMBER</mat-label>

                            <input
                                [disabled]="imInSubscriptionsManagement"
                                [formControl]="vatNumber"
                                matInput
                                required
                                [(ngModel)]="c.VATNumber"
                                name="VATNumber"
                                placeholder="{{ '' | translate }}"
                            />

                            <mat-hint *ngIf="vatNumber.errors && !vatNumber.valid && vatNumber.touched" class="mandatory" translate
                                >USER_FORM.ERROR_REQUIRED</mat-hint
                            >
                        </mat-form-field>
                    </div>
                    <div *ngIf="showWarning">
                        <span class="material-icons warning-icon" matTooltip="{{ warning }}" matTooltipClass="tooltip-layout">warning</span>
                    </div>
                </div>
                <div style="margin-bottom: 1.5rem">
                    <a
                        target="_blank "
                        href="{{ onClick(c.Country) }}"
                        *ngIf="(showWarning && c.Country === 'IT') || c.Country === 'GB'"
                        translate
                        >COMMONS.LINK_VAT_NUMBER</a
                    >
                </div>

                <mat-form-field appearance="outline">
                    <mat-label translate>USER_FORM.FISCALCODE</mat-label>
                    <input #fiscalCode="ngModel" matInput [(ngModel)]="c.FiscalCode" name="FiscalCode" />
                    <mat-hint *ngIf="fiscalCode.errors && !fiscalCode.valid && fiscalCode.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>
            </div>
        </mat-card-content>
        <mat-card-actions style="text-align: right" *ngIf="!imInSubscriptionsManagement">
            <div class="divCardActionColumn">
                <div>
                    <button mat-flat-button type="reset" class="left" color="primary" [disabled]="!signupForm.dirty" (click)="cancel()">
                        <span translate>B_CANCEL</span>
                    </button>
                    <button mat-flat-button color="primary" [disabled]="this.signupForm.invalid || this.disableSaveButton" (click)="save()">
                        <span translate>B_SAVE</span>
                    </button>
                </div>
            </div>
        </mat-card-actions>
    </form>
</mat-card>
<div *ngIf="this.loading">
    <tb-loading></tb-loading>
</div>
